import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-adjust-large.tsx
/**
* icon.24.adjust.large
*
* edit, knobs, settings, configure, config, admin
*
* Keywords: sliders, vertical, controls, settings, adjustment, equalizer, faders
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTcuNSAyMGEuNS41IDAgMCAwIC41LS41di0yLjA0MmEzIDMgMCAwIDAgMC01LjkxN1Y0LjVhLjUuNSAwIDAgMC0xIDB2Ny4wNDFhMy4wMDEgMy4wMDEgMCAwIDAgMCA1LjkxN1YxOS41YS41LjUgMCAwIDAgLjUuNW05IDBhLjUuNSAwIDAgMCAuNS0uNXYtNy4wNDFhMy4wMDEgMy4wMDEgMCAwIDAgMC01LjkxN1Y0LjVhLjUuNSAwIDAgMC0xIDB2Mi4wNDJhMyAzIDAgMCAwIDAgNS45MTdWMTkuNWEuNS41IDAgMCAwIC41LjVtMC04LjVhMiAyIDAgMSAxIDAtNCAyIDIgMCAwIDEgMCA0bS05IDVhMiAyIDAgMSAxIDAtNCAyIDIgMCAwIDEgMCA0Ii8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-1557
*/
const Icon24AdjustLarge = memo(function Icon24AdjustLarge(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M7.5 20a.5.5 0 0 0 .5-.5v-2.042a3 3 0 0 0 0-5.917V4.5a.5.5 0 0 0-1 0v7.041a3.001 3.001 0 0 0 0 5.917V19.5a.5.5 0 0 0 .5.5m9 0a.5.5 0 0 0 .5-.5v-7.041a3.001 3.001 0 0 0 0-5.917V4.5a.5.5 0 0 0-1 0v2.042a3 3 0 0 0 0 5.917V19.5a.5.5 0 0 0 .5.5m0-8.5a2 2 0 1 1 0-4 2 2 0 0 1 0 4m-9 5a2 2 0 1 1 0-4 2 2 0 0 1 0 4"
		})
	});
});
//#endregion
export { Icon24AdjustLarge };

//# sourceMappingURL=icon-24-adjust-large.js.map